<!-- Background wrapper -->
<div class="flex w-full items-center justify-center" [class]="minHeightClass()">
  <!-- Gradient spots -->
  <div class="hidden lg:absolute w-[27.428rem] h-[21.272rem] left-[4rem] top-[23rem] rotate-[140.09deg]">
    <div class="w-full h-full bg-[#DEFF96]/[0.14] blur-[8.675rem] rounded-full"></div>
  </div>
  <div class="hidden lg:absolute w-[19.313rem] h-[26.188rem] left-[50rem] top-[4rem] rotate-[37.24deg]">
    <div class="w-full h-full bg-[#EBDAFF]/[0.29] blur-[8.675rem] rounded-full"></div>
  </div>

  <!-- Content wrapper -->
  <div
    class="relative h-full w-fit flex flex-col items-center"
    [class.px-0]="!isInDialog()"
    [class.mb-4]="!isInDialog()"
    [class.z-30]="!isInDialog()"
    [class.mt-4]="!isInDialog()"
    [class.m-2]="!isInDialog()"
  >
    <!-- Profile Card -->
    <div id="profile-card" class="flex flex-col max-w-xl w-full">
      <!-- Back Button -->
      <app-back-button></app-back-button>

      <div class="flex flex-col bg-white rounded-3xl shadow-sm sm:min-w-[575px] space-y-4 p-3 sm:p-6">
        @if (publicProfileStore.isLoading()) {
          <!-- Loading Skeleton -->
          <app-loading-skeleton></app-loading-skeleton>
        } @else {
          <!-- Profile Header -->
          <app-profile-header></app-profile-header>

          @if (!data?.shortId) {
            <!-- Pay Button -->
            <app-nicky-button
              id="pay"
              variant="primary"
              [disabled]="!publicProfileStore.canMakePayment()"
              (click)="handleRequiredPaymentRequest()"
              [fullWidth]="true"
            >
              {{ 'public-profile.pay' | translate }}
            </app-nicky-button>
          }

          <!-- Payment Methods -->
          @if (!data) {
            <app-payment-methods></app-payment-methods>
          }

          <!-- Description -->
          @if (publicProfileStore.hasBio()) {
            <div class="text-gray-600 text-sm whitespace-pre-wrap">
              {{ publicProfileStore.profileInfo()?.bio }}
            </div>
          }

          @if (data?.shortId) {
            <app-nicky-button
              cdkFocusInitial
              id="done"
              variant="primary"
              (click)="dialogRef?.close()"
              [fullWidth]="true"
            >
              {{ 'close' | translate }}
            </app-nicky-button>
          }
        }
      </div>
    </div>

    @if (!data?.shortId) {
      <!-- Footer -->
      <div class="max-w-xl w-full mt-4 flex justify-end gap-4">
        <a class="link text-sm text-gray-500" [href]="privacyPolicyUrl" target="_blank" rel="noopener noreferrer">
          {{ 'PUBLIC_PROFILE.privacy' | translate }}
        </a>
        <a class="link text-sm text-gray-500" [href]="termsOfUseUrl" target="_blank" rel="noopener noreferrer">
          {{ 'PUBLIC_PROFILE.terms' | translate }}
        </a>
      </div>
    }
  </div>
</div>
